// extracted by mini-css-extract-plugin
module.exports = {"contactUsBox":"ContactUs_contactUsBox__WWM8b","linksBox":"ContactUs_linksBox__AO7Uv","leftToRight":"ContactUs_leftToRight__hqAR8"};